import { apiClient } from './client'

export type LearningDemoOutcome = 'COMPLETED' | 'SKIPPED'

export const onboardingApi = {
  getLearningDemoStatus: () =>
    apiClient
      .get<{ completed: boolean }>('/onboarding/learning-demo/status')
      .then((response) => response.data),

  completeLearningDemo: (outcome: LearningDemoOutcome) =>
    apiClient.post<{ status: string; outcome: string }>('/onboarding/learning-demo/complete', {
      outcome,
    }),
}
